import React from 'react';
import imgPlaceholder from '../../../assets/img/img-placement.svg';
import successIcon from '../../../assets/img/sucess-two.svg';

const UploadFileCircularBar = ({
    imgStyle,
    text,
    uploadProgress,
    size = 30,
    strokeWidth = 3
}) => {
    const center = size / 2;
    const radius = center - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (uploadProgress / 100) * circumference;

    return (
        <div className="upload-file-circular-bar d-flex align-items-center mt-2 mb-3">
            <img src={imgPlaceholder} alt="upload" style={imgStyle ? imgStyle : {}} />
            <div className="ml-3 info-container d-flex align-items-center">
                <div className="text-container">
                    <span className="file-text">{text}</span>
                </div>
                <div className="circular-progress">
                    {uploadProgress === 100 ? (
                        <img
                            src={successIcon}
                            alt=""
                            style={{ width: size, height: size }}
                        />
                    ) : (
                        <svg width={size} height={size}>
                            {/* Background circle */}
                            <circle
                                className="progress-bg"
                                stroke="#f3f3f3"
                                fill="none"
                                strokeWidth={strokeWidth}
                                cx={center}
                                cy={center}
                                r={radius}
                            />
                            {/* Progress circle */}
                            <circle
                                className="progress-bar"
                                stroke="#4caf50"
                                fill="none"
                                strokeWidth={strokeWidth}
                                cx={center}
                                cy={center}
                                r={radius}
                                strokeDasharray={circumference}
                                strokeDashoffset={offset}
                                strokeLinecap="round"
                                transform={`rotate(-90 ${center} ${center})`}
                            />
                            {/* Progress text in the center */}
                            <text
                                x="50%"
                                y="50%"
                                dominantBaseline="central"
                                textAnchor="middle"
                                fontSize="9"
                                fill="#4caf50"
                            >
                                {uploadProgress}%
                            </text>
                        </svg>
                    )}
                </div>
            </div>
            <style jsx>{`
                .upload-file-circular-bar {
                    width: 100%;
                }
                .info-container {
                    width: 100%;
                    display: flex;
                    align-items: center;
                }
                .text-container {
                    /* The text stays to the left */
                }
                .file-text {
                    font-family: Hind, sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 28.82px;
                    display: block;
                }
                .circular-progress {
                    margin-left: auto; /* This pushes the circular progress to the right */
                    margin-top: 4px;
                }
            `}</style>
        </div>
    );
};

export default UploadFileCircularBar;
